export const QUERY_TIERS = {
  /** Balance, allowances — fresh data matters, but refresh on events not polling */
  financial: { staleTime: 60_000, gcTime: 300_000, retry: 1 },
  /** Actions list, policies, dropdown options — moderate freshness */
  operational: { staleTime: 120_000, gcTime: 600_000, retry: 2 },
  /** Profiles, helpers, safes, trustors — rarely changes */
  profile: {
    staleTime: 300_000,
    gcTime: 900_000,
    retry: 2,
    refetchOnWindowFocus: false as const,
  },
  /** Modal queries — short-lived, cleaned up on close */
  ephemeral: {
    staleTime: 30_000,
    gcTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false as const,
  },
} as const;
